import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// import FlightLoader from "../AirSearch/Flightloader";
import AirplaneLoader from "./AirplaneLoader";
const formatTime = (iso) => { if (!iso) return "N/A"; return iso.split("T")[1]?.substring(0, 5) || iso; };
const formatDur = (val) => { if (!val) return "N/A"; if (typeof val === "string") return val; return `${Math.floor(val / 60)}h ${val % 60}m`; };
const depHour = (dep) => parseInt((dep || "00").split(":")[0]);
const timeSlot = (dep) => { const h = depHour(dep); if (h < 6) return 1; if (h < 12) return 2; if (h < 18) return 3; return 4; };

const AIRLINE_LOGO_MAP = {
  // "6E": "indigo",
  // "AI": "airindia",
};

const getLogoFileName = (code) => AIRLINE_LOGO_MAP[code] || code || "default";

const getDisplayData = (flight) => {
  const onwardSegs = flight?.AirSegments?.filter(s => s.SegmentType === "Onword") || [];
  const returnSegs = flight?.AirSegments?.filter(s => s.SegmentType === "Return") || [];

  const seg     = onwardSegs[0] || flight?.AirSegments?.[0];
  const lastSeg = onwardSegs[onwardSegs.length - 1] || seg;
  const onwardFare = flight?.AirlineFares?.find(f => f.ContractType === "Onword") || flight?.AirlineFares?.[0];
  const fare = flight?.AirlineFare || onwardFare || {};

  const returnSeg     = returnSegs[0];
  const lastReturnSeg = returnSegs[returnSegs.length - 1];
  const onwardStops = onwardSegs.length > 1 ? onwardSegs.length - 1 : 0;
  const returnStops = returnSegs.length > 1 ? returnSegs.length - 1 : 0;

  const onwardDur = flight?.ContractDuration?.find(d => d.ContractType === "Onword")?.TripDuration || seg?.Duration || "";
  const returnDur = flight?.ContractDuration?.find(d => d.ContractType === "Return")?.TripDuration || returnSeg?.Duration || "";

  return {
    airline:      seg?.AirlineName    || "Airline",
    airlineCode:  seg?.AirlineCode    || "",
    code:         `${seg?.AirlineCode || ""}-${seg?.FlightNumber || ""}`,
    logo:         (seg?.AirlineCode   || "?").substring(0, 2),
    dep:        formatTime(seg?.DepartureDateTime),
    arr:        formatTime(lastSeg?.ArrivalDateTime),
    durMin:     onwardDur,
    stops:      onwardStops,
    price:      fare?.GrossFare || fare?.BaseFare || flight?.GrossFare || 0,
    baseFare:   fare?.BaseFare  || 0,
    tax:        fare?.TaxFare   || fare?.Tax || 0,
    baggage:    seg?.BaggageAllowed?.CheckInBaggage || "N/A",
    handBag:    seg?.BaggageAllowed?.HandBaggage    || "N/A",
    origin:     seg?.Origen         || "DEL",
    originCity: seg?.SourceCity     || "",
    dest:       lastSeg?.Destination     || "BOM",
    destCity:   lastSeg?.DestinationCity || "",
    segType:    seg?.SegmentType    || "",
    isRoundTrip:      returnSegs.length > 0,
    retDep:           formatTime(returnSeg?.DepartureDateTime),
    retArr:           formatTime(lastReturnSeg?.ArrivalDateTime),
    retAirlineCode:   returnSeg?.AirlineCode || seg?.AirlineCode || "",
    retOrigin:        returnSeg?.Origen       || "",
    retOriginCity:    returnSeg?.SourceCity   || "",
    retDest:          lastReturnSeg?.Destination     || "",
    retDestCity:      lastReturnSeg?.DestinationCity || "",
    retDurMin:        returnDur,
    retStops:         returnStops,
    retBaggage:       returnSeg?.BaggageAllowed?.CheckInBaggage || "N/A",
    fareGroups:       flight?.FareGroups?.FareGroup || [],
  };
};

const S = {
  page: { fontFamily: "'Segoe UI', system-ui, sans-serif", background: "#F5F6FA", minHeight: "100vh", color: "#1a1a2e" },
  topBar: { background: "#034494", padding: "10px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" },
  metaRow: { display: "flex", flex: 1, alignItems: "center" },
  metaItem: { display: "flex", flexDirection: "column", gap: 2, flex: 1 },
  metaLabel: { fontSize: 13, color: "#fff", fontWeight: 700, letterSpacing: ".3px" },
  metaVal: { fontSize: 13, color: "#ffffffcc" },
  modifyBtn: { background: "#e91e63", color: "#fff", border: "none", borderRadius: 4, padding: "8px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" },
  modPanel: { background: "#fff", borderBottom: "1px solid #E8EAF0", padding: "16px 20px" },
  tripRadios: { display: "flex", gap: 6, marginBottom: 14 },
  searchRow: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: 8, alignItems: "end" },
  fieldBox: { background: "#F5F6FA", border: "1px solid #E8EAF0", borderRadius: 8, padding: "8px 12px", cursor: "pointer" },
  fieldLbl: { fontSize: 10, color: "#9295A4", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 3, fontWeight: 500 },
  fieldCity: { fontSize: 20, fontWeight: 700, lineHeight: 1.1, color: "#1a1a2e" },
  fieldSub: { fontSize: 11, color: "#9295A4" },
  swapBtn: { background: "#fff", border: "1px solid #E8EAF0", width: 30, display: "flex", alignItems: "center", justifyContent: "center", color: "#6B6F80", fontSize: 12 },
  btnSearch: { background: "#1a73e8", color: "#fff", border: "none", borderRadius: 8, padding: "12px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer", height: 44 },
  mainArea: { display: "flex", gap: 14, padding: "14px 20px" },
  filterCard: { width: 210, flexShrink: 0, background: "#fff", border: "1px solid #E8EAF0", borderRadius: 10, overflow: "hidden", alignSelf: "start" },
  filterHead: { padding: "10px 14px", borderBottom: "1px solid #E8EAF0", display: "flex", justifyContent: "space-between", alignItems: "center" },
  filterSec: { padding: "12px 14px", borderBottom: "1px solid #F0F1F5" },
  filterTitle: { fontSize: 11, fontWeight: 600, color: "#9295A4", textTransform: "uppercase", letterSpacing: ".5px", marginBottom: 8 },
  resetLink: { fontSize: 11, color: "#1a73e8", cursor: "pointer", background: "none", border: "none", fontWeight: 500 },
  stopBtns: { display: "flex", gap: 6 },
  resultsArea: { flex: 1, minWidth: 0 },
  sortTabs: { display: "flex", background: "#fff", border: "1px solid #E8EAF0", borderRadius: 10, overflow: "hidden", marginBottom: 10 },
  sortTab: { flex: 1, padding: "10px 8px", textAlign: "center", cursor: "pointer", fontSize: 12 },
  navBtns: { display: "flex", gap: 8, marginBottom: 10, alignItems: "center" },
  navBtn: { padding: "6px 14px", border: "1px solid #E8EAF0", borderRadius: 8, fontSize: 12, cursor: "pointer", background: "#fff", color: "#6B6F80" },
  colHead: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 6, padding: "4px 14px", fontSize: 10, color: "#9295A4", fontWeight: 600, textTransform: "uppercase", letterSpacing: ".4px", marginBottom: 4 },
  flightCard: { background: "#fff", border: "1px solid #E8EAF0", borderRadius: 10, marginBottom: 8, overflow: "hidden" },
  flightRow: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 6, padding: "12px 14px", alignItems: "center" },
  returnRow: { display: "grid", gridTemplateColumns: "2fr 1.1fr 1.2fr 1.1fr 1.2fr", gap: 6, padding: "10px 14px", alignItems: "center", background: "#f8f9ff", borderTop: "1px dashed #c7d7f5" },
  detailBar: { borderTop: "1px solid #F0F1F5", padding: "7px 14px", display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" },
  timeBig: { fontSize: 16, fontWeight: 700, color: "#1a1a2e" },
  timeSub: { fontSize: 10, color: "#9295A4" },
  priceAmt: { fontSize: 18, fontWeight: 700, color: "#1a1a2e" },
  priceSub: { fontSize: 10, color: "#9295A4", marginBottom: 2 },
  bookBtn: { background: "#1a73e8", color: "#fff", border: "none", borderRadius: 7, padding: "6px 14px", fontSize: 12, fontWeight: 600, cursor: "pointer", marginTop: 5 },
  badgeGreen: { background: "#E6F4EA", color: "#27600A", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 500 },
  badgeGray: { background: "#F0F1F5", color: "#6B6F80", padding: "2px 8px", borderRadius: 20, fontSize: 11 },
  badgeAmber: { background: "#FFF3E0", color: "#854F0B", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 500 },
  tripLabel: { fontSize: 10, fontWeight: 600, padding: "1px 7px", borderRadius: 4, marginBottom: 2, display: "inline-block" },
  logoBox: { width: 34, height: 34, borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", flexShrink: 0 },
  logoImg: { width: "100%", height: "100%", objectFit: "contain" },
  loadingMore: { textAlign: "center", padding: "16px 0", color: "#9295A4", fontSize: 12 },
};

const LOGO_COLORS = ["#D0021B","#1a73e8","#FF6600","#6B21A8","#059669","#e91e63","#0097A7","#F57C00"];
const AIRLINES_LIST = ["Air India","Indigo","SpiceJet","Vistara","GoFirst","Air Asia","Saudi Arabian Airlines","Emirates","Etihad"];

// ✅ Shared airport-loading helper — same pattern/endpoints as the homepage,
// with fallbacks so it works regardless of which route the user lands on first.
async function loadAirportsShared(setAirports) {
  const stored = localStorage.getItem("airports");
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        setAirports(parsed);
        return;
      }
    } catch (e) {
      localStorage.removeItem("airports");
    }
  }

  // Try #1: env/proxy based endpoint (same as homepage's second effect)
  try {
    const AIRPORTS_ENDPOINT = process.env.NODE_ENV === "development"
      ? "/api/Air/Airports"
      : `${process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_FLIGHTS_API_URL}/Air/Airports`;

    const res = await fetch(AIRPORTS_ENDPOINT, {
      method: "GET",
      headers: { Accept: "application/json" },
    });
    if (res.ok) {
      const data = await res.json();
      const arr = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);
      if (arr.length > 0) {
        setAirports(arr);
        localStorage.setItem("airports", JSON.stringify(arr));
        return;
      }
    }
  } catch (err) {
    console.warn("Airport GET fetch failed, trying POST fallback:", err.message);
  }

  // Try #2: hardcoded POST endpoint (same as homepage's first effect)
  try {
    const res = await fetch("https://promo.namantechnolab.com/api/Air/Airports", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });
    if (res.ok) {
      const data = await res.json();
      const arr = Array.isArray(data) ? data : (data?.data && Array.isArray(data.data) ? data.data : []);
      if (arr.length > 0) {
        setAirports(arr);
        localStorage.setItem("airports", JSON.stringify(arr));
        return;
      }
    }
  } catch (err) {
    console.error("Airport POST fallback also failed:", err.message);
  }
}

function AirlineLogo({ airlineCode, bgColor, textColor, initials }) {
  const [imgError, setImgError] = useState(false);
  const fileName = getLogoFileName(airlineCode);

  if (imgError || !airlineCode) {
    return (
      <div style={{ ...S.logoBox, background: bgColor + "22", color: textColor, fontSize: 10, fontWeight: 700 }}>
        {initials}
      </div>
    );
  }

  return (
    <div style={{ ...S.logoBox, background: "#fff", border: "1px solid #F0F1F5" }}>
      <img
        src={`/Flight_Images/${fileName}.gif`}
        alt={airlineCode}
        style={S.logoImg}
        onError={() => setImgError(true)}
      />
    </div>
  );
}

function ModifyPanel({ tripType, setTripType, navigate }) {
  const [from, setFrom] = useState({ city: "Delhi", code: "DEL", name: "Indira Gandhi International" });
  const [to, setTo] = useState({ city: "Mumbai", code: "BOM", name: "Chhatrapati Shivaji International" });
  const [fromQuery, setFromQuery] = useState("Delhi");
  const [toQuery, setToQuery] = useState("Mumbai");
  const [fromSuggestions, setFromSuggestions] = useState([]);
  const [toSuggestions, setToSuggestions] = useState([]);
  const [airports, setAirports] = useState([]);
  const [departDate, setDepartDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [adults, setAdults] = useState(1);
  const [children, setChildren] = useState(0);
  const [infants, setInfants] = useState(0);

  const fromRef = useRef(null);
  const toRef = useRef(null);
const [inrToAed, setInrToAed] = useState(null);

  // ✅ Airports load — same pattern as homepage, with GET+POST fallback
  useEffect(() => {
    loadAirportsShared(setAirports);
  }, []);

  // 🔍 debug — remove once confirmed working
  useEffect(() => {
    console.log("✅ [ModifyPanel] Airports loaded:", airports.length);
  }, [airports]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (fromRef.current && !fromRef.current.contains(e.target)) setFromSuggestions([]);
      if (toRef.current && !toRef.current.contains(e.target)) setToSuggestions([]);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getFilteredAirports = (query) => {
    if (!Array.isArray(airports)) return [];
    const q = (query || "").trim().toLowerCase();
    return airports.filter(a =>
      (a.CityName && a.CityName.toLowerCase().includes(q)) ||
      (a.AirportCode && a.AirportCode.toLowerCase().includes(q)) ||
      (a.AirportName && a.AirportName.toLowerCase().includes(q))
    );
  };

  const handleFromChange = (e) => {
    const value = e.target.value;
    setFromQuery(value);
    setFromSuggestions(value.trim().length >= 3 ? getFilteredAirports(value).slice(0, 10) : []);
  };

  const handleToChange = (e) => {
    const value = e.target.value;
    setToQuery(value);
    setToSuggestions(value.trim().length >= 3 ? getFilteredAirports(value).slice(0, 10) : []);
  };

  // ✅ NEW — reopen suggestions on focus if query already qualifies
  const handleFromFocus = () => {
    if (fromQuery.trim().length >= 3) setFromSuggestions(getFilteredAirports(fromQuery).slice(0, 10));
  };
  const handleToFocus = () => {
    if (toQuery.trim().length >= 3) setToSuggestions(getFilteredAirports(toQuery).slice(0, 10));
  };

  const selectFromAirport = (a) => {
    setFrom({ city: a.CityName, code: a.AirportCode, name: a.AirportName });
    setFromQuery(a.CityName);
    setFromSuggestions([]);
  };

  const selectToAirport = (a) => {
    setTo({ city: a.CityName, code: a.AirportCode, name: a.AirportName });
    setToQuery(a.CityName);
    setToSuggestions([]);
  };

  const handleSwap = () => {
    const tf = from, tt = to;
    setFrom(tt); setTo(tf);
    setFromQuery(tt.city); setToQuery(tf.city);
  };

  const handleSearch = () => {
    const routs = [{
      Source: from.code,
      InputSource: `${from.code} - ${from.name}`,
      Destination: to.code,
      OutputSource: `${to.code} - ${to.name}`,
      TravelDate: departDate,
    }];
    if (tripType === "Round trip") {
      routs.push({
        Source: to.code,
        InputSource: `${to.code} - ${to.name}`,
        Destination: from.code,
        OutputSource: `${from.code} - ${from.name}`,
        TravelDate: returnDate,
      });
    }
    const payload = {
      APIToken: null,
      AgencyKey: "4AC0F2DD-66C2-4AC1-8AFD-DE615E223A4A",
      AdultCount: Number(adults) || 1,
      ChildCount: Number(children) || 0,
      InfantCount: Number(infants) || 0,
      PreferredAirlines: null,
      Routs: routs,
      TripType: tripType === "Round trip" ? 1 : 0,
      TypeOfClass: 0,
      IsDomestic: true,
      SetAirport: null,
      IsB2B: false,
      IsSpecailFlight: false,
      FromCity: null,
      Tocity: null,
      TransactionId: 0,
      EngineType: 0,
      AccountNo: 17,
    };
    navigate("/AirResponse/Index", { state: { searchData: payload } });
  };

  return (
    <div style={S.modPanel}>
      <div style={S.tripRadios}>
        {["One way", "Round trip"].map((t) => (
          <span key={t} onClick={() => setTripType(t)}
            style={{ padding: "5px 14px", border: `1px solid ${tripType === t ? "#1a73e8" : "#D0D3E0"}`,
              borderRadius: 20, fontSize: 12, cursor: "pointer",
              background: tripType === t ? "#1a73e8" : "#fff",
              color: tripType === t ? "#fff" : "#1a1a2e" }}>
            {t}
          </span>
        ))}
      </div>
      <div style={S.searchRow}>
        <div style={{ display: "flex", alignItems: "stretch" }}>
          <div ref={fromRef} style={{ ...S.fieldBox, flex: 1, borderRadius: "8px 0 0 8px", borderRight: "none", position: "relative" }}>
            <div style={S.fieldLbl}>From</div>
            <input
              value={fromQuery}
              onChange={handleFromChange}
              onFocus={handleFromFocus}
              autoComplete="off"
              style={{ border: "none", background: "transparent", fontSize: 18, fontWeight: 700, width: "100%", outline: "none" }}
            />
            <div style={S.fieldSub}>{from.code} - {from.name}</div>
            {fromSuggestions.length > 0 && (
              <ul style={{ position: "absolute", top: "100%", left: 0, zIndex: 50, background: "#fff",
                width: "100%", listStyle: "none", padding: 8, margin: 0, border: "1px solid #E8EAF0",
                maxHeight: 220, overflowY: "auto", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
                {fromSuggestions.map((a, i) => (
                  <li key={a.ID || i} onClick={() => selectFromAirport(a)}
                    style={{ cursor: "pointer", padding: "8px 6px", borderBottom: "1px solid #f0f0f0" }}>
                    <strong style={{ fontSize: 13 }}>{a.CityName} ({a.AirportCode})</strong>
                    <div style={{ fontSize: 11, color: "#666" }}>{a.AirportName}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
          <div onClick={handleSwap} style={{ ...S.swapBtn, borderRadius: 0, borderLeft: "1px solid #E8EAF0", borderRight: "1px solid #E8EAF0", alignSelf: "stretch", cursor: "pointer" }}>⇄</div>
          <div ref={toRef} style={{ ...S.fieldBox, flex: 1, borderRadius: "0 8px 8px 0", borderLeft: "none", position: "relative" }}>
            <div style={S.fieldLbl}>To</div>
            <input
              value={toQuery}
              onChange={handleToChange}
              onFocus={handleToFocus}
              autoComplete="off"
              style={{ border: "none", background: "transparent", fontSize: 18, fontWeight: 700, width: "100%", outline: "none" }}
            />
            <div style={S.fieldSub}>{to.code} - {to.name}</div>
            {toSuggestions.length > 0 && (
              <ul style={{ position: "absolute", top: "100%", left: 0, zIndex: 50, background: "#fff",
                width: "100%", listStyle: "none", padding: 8, margin: 0, border: "1px solid #E8EAF0",
                maxHeight: 220, overflowY: "auto", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}>
                {toSuggestions.map((a, i) => (
                  <li key={a.ID || i} onClick={() => selectToAirport(a)}
                    style={{ cursor: "pointer", padding: "8px 6px", borderBottom: "1px solid #f0f0f0" }}>
                    <strong style={{ fontSize: 13 }}>{a.CityName} ({a.AirportCode})</strong>
                    <div style={{ fontSize: 11, color: "#666" }}>{a.AirportName}</div>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div style={S.fieldBox}>
          <div style={S.fieldLbl}>Departure</div>
          <input type="date" value={departDate} onChange={(e) => setDepartDate(e.target.value)}
            style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 600, width: "100%" }} />
        </div>
        <div style={{ ...S.fieldBox, opacity: tripType === "Round trip" ? 1 : 0.4 }}>
          <div style={S.fieldLbl}>Return</div>
          <input type="date" value={returnDate} disabled={tripType !== "Round trip"}
            onChange={(e) => setReturnDate(e.target.value)} min={departDate}
            style={{ border: "none", background: "transparent", fontSize: 14, fontWeight: 600, width: "100%" }} />
        </div>
        <div style={S.fieldBox}>
          <div style={S.fieldLbl}>Travellers &amp; class</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>{adults + children + infants} Traveller</div>
          <div style={S.fieldSub}>Economy class</div>
        </div>
        <button style={S.btnSearch} onClick={handleSearch}>Search</button>
      </div>
    </div>
  );
}

function FilterPanel({ filters, setFilters }) {
  const toggle = (key, val) => 
    setFilters((f) => ({ ...f, [key]: f[key].includes(val) ? f[key].filter((x) => x !== val) : [...f[key], val] }));
  const resetAll = () => setFilters({ maxPrice: 100000, stops: [], depSlots: [], airlines: [] });

  return (
    <div style={S.filterCard}>
      <div style={S.filterHead}>
        <span style={{ fontSize: 12, fontWeight: 600, color: "#1a1a2e" }}>Filters</span>
        <button style={S.resetLink} onClick={resetAll}>↺ Reset</button>
      </div>
      <div style={S.filterSec}>
        <div style={S.filterTitle}>Price</div>
        <input type="range" min={3000} max={300000} step={500} value={filters.maxPrice}
          onChange={(e) => setFilters((f) => ({ ...f, maxPrice: +e.target.value }))}
          style={{ width: "100%", accentColor: "#1a73e8" }} />
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: "#9295A4", marginTop: 3 }}>
          <span>₹3,000</span><span>₹{filters.maxPrice.toLocaleString("en-IN")}</span>
        </div>
      </div>
      <div style={S.filterSec}>
        <div style={S.filterTitle}>Stops</div>
        <div style={S.stopBtns}>
          {[0, 1, 2].map((s) => {
            const active = filters.stops.includes(s);
            return (
              <div key={s} onClick={() => toggle("stops", s)} style={{ flex: 1, padding: "6px 4px", border: `1px solid ${active ? "#1a73e8" : "#E8EAF0"}`, borderRadius: 8, fontSize: 12, textAlign: "center", cursor: "pointer", background: active ? "#E8F0FE" : "#F5F6FA", color: active ? "#1a73e8" : "#6B6F80", fontWeight: active ? 600 : 400 }}>
                <div style={{ fontSize: 15, fontWeight: 700 }}>{s === 2 ? "1+" : s}</div>
                <div style={{ fontSize: 10 }}>stop</div>
              </div>
            );
          })}
        </div>
      </div>
      <div style={S.filterSec}>
        <div style={S.filterTitle}>Departure time</div>
        {[["Early morning","12–6 AM",1],["Morning","6–12 PM",2],["Afternoon","12–6 PM",3],["Evening","6–12 AM",4]].map(([lbl, range, slot]) => (
          <label key={slot} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "3px 0", fontSize: 12, cursor: "pointer" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <input type="checkbox" checked={filters.depSlots.includes(slot)} onChange={() => toggle("depSlots", slot)} style={{ accentColor: "#1a73e8" }} />
              {lbl}
            </span>
            <span style={{ fontSize: 11, color: "#9295A4" }}>{range}</span>
          </label>
        ))}
      </div>
      <div style={{ ...S.filterSec, borderBottom: "none" }}>
        <div style={S.filterTitle}>Airlines</div>
        {AIRLINES_LIST.map((a) => (
          <label key={a} style={{ display: "flex", alignItems: "center", gap: 6, padding: "3px 0", fontSize: 12, cursor: "pointer" }}>
            <input type="checkbox" checked={filters.airlines.includes(a)} onChange={() => toggle("airlines", a)} style={{ accentColor: "#1a73e8" }} />
            {a}
          </label>
        ))}
      </div>
    </div>
  );
}

function FlightCard({ flight, index, sessionData, isDomestic, searchData, passengersArray  }) {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const d = getDisplayData(flight);
  const lc = LOGO_COLORS[index % LOGO_COLORS.length];

  return (
    <div style={S.flightCard}>

      {/* ✅ ONWARD ROW */}
      <div style={S.flightRow}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <AirlineLogo airlineCode={d.airlineCode} bgColor={lc} textColor={lc} initials={d.logo} />
          <div>
            <span style={{ ...S.tripLabel, background: "#e8f0fe", color: "#1a73e8" }}>✈ ONWARD</span>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e" }}>{d.airline}</div>
            <div style={{ fontSize: 11, color: "#9295A4" }}>{d.code}</div>
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={S.timeBig}>{d.dep}</div>
          <div style={S.timeSub}>{d.origin}</div>
          {d.originCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.originCity}</div>}
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontSize: 11, color: "#9295A4" }}>{formatDur(d.durMin)}</div>
          <div style={{ position: "relative", margin: "4px 0" }}>
            <div style={{ height: 1, background: "#D0D3E0", position: "relative" }}>
              <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, left: 0 }} />
              <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, right: 0 }} />
            </div>
          </div>
          <span style={d.stops === 0 ? S.badgeGreen : S.badgeAmber}>
            {d.stops === 0 ? "Non-stop" : `${d.stops} stop`}
          </span>
        </div>
        <div style={{ textAlign: "center" }}>
          <div style={S.timeBig}>{d.arr}</div>
          <div style={S.timeSub}>{d.dest}</div>
          {d.destCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.destCity}</div>}
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={S.priceSub}>per person</div>
          <div style={S.priceAmt}>₹{Number(d.price).toLocaleString("en-IN")}</div>
        <button
  style={S.bookBtn}
  onClick={() =>
    navigate("/FareDetails", {
      state: {
        flight,
        apiToken:   sessionData?.apiToken,
        agencyKey:  sessionData?.agencyKey,
        bookingKey: sessionData?.bookingKey,
        IsDomestic: isDomestic,
        passengers: passengersArray,
        AdultCount:  searchData?.AdultCount  || 1,
        ChildCount:  searchData?.ChildCount  || 0,
        InfantCount: searchData?.InfantCount || 0,
      }
    })
  }
>
  Book now
</button>
        </div>
      </div>

      {/* ✅ RETURN ROW — sirf round trip mein */}
      {d.isRoundTrip && (
        <div style={S.returnRow}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <AirlineLogo airlineCode={d.retAirlineCode} bgColor={lc} textColor={lc} initials={d.logo} />
            <div>
              <span style={{ ...S.tripLabel, background: "#fce4ec", color: "#c2185b" }}>↩ RETURN</span>
              <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e" }}>{d.airline}</div>
              <div style={{ fontSize: 11, color: "#9295A4" }}>{d.code}</div>
            </div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={S.timeBig}>{d.retDep}</div>
            <div style={S.timeSub}>{d.retOrigin}</div>
            {d.retOriginCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.retOriginCity}</div>}
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 11, color: "#9295A4" }}>{formatDur(d.retDurMin)}</div>
            <div style={{ position: "relative", margin: "4px 0" }}>
              <div style={{ height: 1, background: "#D0D3E0" }}>
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, left: 0 }} />
                <div style={{ width: 5, height: 5, borderRadius: "50%", background: "#D0D3E0", position: "absolute", top: -2, right: 0 }} />
              </div>
            </div>
            <span style={d.retStops === 0 ? S.badgeGreen : S.badgeAmber}>
              {d.retStops === 0 ? "Non-stop" : `${d.retStops} stop`}
            </span>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={S.timeBig}>{d.retArr}</div>
            <div style={S.timeSub}>{d.retDest}</div>
            {d.retDestCity && <div style={{ fontSize: 10, color: "#9295A4" }}>{d.retDestCity}</div>}
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 11, color: "#6B6F80", fontWeight: 500 }}>Round Trip</div>
            <div style={{ fontSize: 10, color: "#9295A4" }}>Incl. in fare</div>
          </div>
        </div>
      )}

      {/* Detail Bar */}
      <div style={S.detailBar}>
        <span style={S.badgeGray}>🧳 {d.baggage}</span>
        <span style={S.badgeGray}>💼 {d.handBag}</span>
        {d.isRoundTrip && <span style={{ ...S.badgeGray, background: "#fce4ec", color: "#c2185b" }}>Round Trip</span>}
        <span
          onClick={() => setExpanded(v => !v)}
          style={{ marginLeft: "auto", fontSize: 11, color: "#1a73e8", cursor: "pointer", fontWeight: 500 }}
        >
          {expanded ? "▲ Hide details" : "▼ Flight details"}
        </span>
      </div>

      {/* Expanded details */}
      {expanded && (
        <div style={{ padding: "10px 14px", background: "#F9FAFB", borderTop: "1px solid #F0F1F5", fontSize: 12, color: "#6B6F80" }}>
          <div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 8 }}>✈ Onward</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, marginBottom: d.isRoundTrip ? 12 : 0 }}>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Departs</div>{d.dep} · {d.origin}{d.originCity && <div style={{ fontSize: 11 }}>{d.originCity}</div>}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Duration</div>{formatDur(d.durMin)}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Arrives</div>{d.arr} · {d.dest}{d.destCity && <div style={{ fontSize: 11 }}>{d.destCity}</div>}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Check-in Baggage</div>{d.baggage}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Hand Baggage</div>{d.handBag}</div>
            <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Stops</div>{d.stops === 0 ? "Non-stop" : `${d.stops} stop(s)`}</div>
          </div>
          {d.isRoundTrip && (
            <>
              <div style={{ fontWeight: 600, color: "#c2185b", marginBottom: 8, marginTop: 8, borderTop: "1px solid #f0f1f5", paddingTop: 8 }}>↩ Return</div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Departs</div>{d.retDep} · {d.retOrigin}{d.retOriginCity && <div style={{ fontSize: 11 }}>{d.retOriginCity}</div>}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Duration</div>{formatDur(d.retDurMin)}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Arrives</div>{d.retArr} · {d.retDest}{d.retDestCity && <div style={{ fontSize: 11 }}>{d.retDestCity}</div>}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Check-in Baggage</div>{d.retBaggage}</div>
                <div><div style={{ fontWeight: 600, color: "#1a1a2e", marginBottom: 2 }}>Stops</div>{d.retStops === 0 ? "Non-stop" : `${d.retStops} stop(s)`}</div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

export default function Index() {
  const location = useLocation();
  const navigate = useNavigate();

  const [flights, setFlights]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState("");
  const [showModify, setShowModify]   = useState(false);
  const [tripType, setTripType]       = useState("One way");
  const [sortTab, setSortTab]         = useState("Best");
  const [filters, setFilters]         = useState({ maxPrice: 300000, stops: [], depSlots: [], airlines: [] });
  const [sessionData, setSessionData] = useState({ apiToken: "", agencyKey: "", bookingKey: "" });
  const ITEMS_PER_PAGE = 10;
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const isDomestic = location.state?.searchData?.IsDomestic ?? true;
  const isRoundTripSearch = (location.state?.searchData?.TripType === 1 || location.state?.searchData?.Routs?.length > 1);

  useEffect(() => {
    const payload = location.state?.searchData;
    if (!payload) { navigate("/"); return; }

    const fetchFlights = async () => {
      try {
        setLoading(true);
        const baseURL = process.env.REACT_APP_FLIGHTS_API_URL;
        if (!baseURL) { setError("API configuration missing"); return; }

        const response = await fetch(`${baseURL}/Trip/AirGroupResults`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        console.log("API Response:", data);
        if (Number(data?.Error?.ErrorCode) !== 0) {
          setError(data?.Error?.ErrorDesc || "API Error");
        } else {
          setSessionData({
            apiToken:   data?.APIToken   || "",
            agencyKey:  data?.AgencyKey  || "",
            bookingKey: data?.BookingKey || "",
          });
          setFlights(data?.Contracts || []);
        }
      } catch (err) {
        console.error("Fetch Error:", err);
        setError("Server Error");
      } finally {
        setLoading(false);
      }
    };

    fetchFlights();
  }, [location.state, navigate]);

  const filteredFlights = useMemo(() => {
    let list = flights.filter((f) => {
      const d = getDisplayData(f);
      if (d.price > filters.maxPrice) return false;
      if (filters.stops.length && !filters.stops.includes(d.stops > 1 ? 2 : d.stops)) return false;
      if (filters.depSlots.length && !filters.depSlots.includes(timeSlot(d.dep))) return false;
      if (filters.airlines.length && !filters.airlines.includes(d.airline)) return false;
      return true;
    });
    if (sortTab === "Cheapest") {
      list = [...list].sort((a, b) => getDisplayData(a).price - getDisplayData(b).price);
    } else if (sortTab === "Fastest") {
      list = [...list].sort((a, b) => String(getDisplayData(a).durMin).localeCompare(String(getDisplayData(b).durMin)));
    } else {
      const maxP = Math.max(...list.map((f) => getDisplayData(f).price), 1);
      list = [...list].sort((a, b) => {
        const da = getDisplayData(a), db = getDisplayData(b);
        return (1 - db.price / maxP) - (1 - da.price / maxP);
      });
    }
    return list;
  }, [flights, filters, sortTab]);

  // ✅ Filters/sort change hone par pagination reset
  useEffect(() => { setVisibleCount(ITEMS_PER_PAGE); }, [filters, sortTab]);

  // ✅ INFINITE SCROLL — neeche scroll karne par apne aap aur 10 result load honge
  useEffect(() => {
    const handleScroll = () => {
      const scrolledToBottom =
        window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 300;
      if (scrolledToBottom) {
        setVisibleCount((prev) => {
          if (prev >= filteredFlights.length) return prev;
          return prev + ITEMS_PER_PAGE;
        });
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [filteredFlights.length]);

  const paginatedFlights = useMemo(() => {
    return filteredFlights.slice(0, visibleCount);
  }, [filteredFlights, visibleCount]);

  const totalPages = Math.ceil(filteredFlights.length / ITEMS_PER_PAGE) || 1;
  const currentPageDisplay = Math.min(Math.ceil(visibleCount / ITEMS_PER_PAGE), totalPages);
  const hasMore = visibleCount < filteredFlights.length;

  const tabMeta = useMemo(() => {
    const byPrice = [...filteredFlights].sort((a, b) => getDisplayData(a).price - getDisplayData(b).price);
    const cheapest = byPrice[0];
    const best = filteredFlights[0];
    return {
      Best:     { price: best     ? getDisplayData(best).price     : "-", dur: best     ? formatDur(getDisplayData(best).durMin)     : "-" },
      Cheapest: { price: cheapest ? getDisplayData(cheapest).price : "-", dur: cheapest ? formatDur(getDisplayData(cheapest).durMin) : "-" },
      Fastest:  { price: cheapest ? getDisplayData(cheapest).price : "-", dur: cheapest ? formatDur(getDisplayData(cheapest).durMin) : "-" },
    };
  }, [filteredFlights]);
  const searchData = location.state?.searchData;

  return (
    <div style={S.page}>
       {loading && (
  <AirplaneLoader 
    message={`Loading    flights from ${searchData?.Routs?.[0]?.Source || "DEL"} to ${searchData?.Routs?.[0]?.Destination || "BOM"}...`} 
  />
)}
      <div style={S.topBar}>
        <div style={S.metaRow}>
          {[
            [isRoundTripSearch ? "Round Trip" : "One Way", `${searchData?.Routs?.[0]?.Source || "DEL"} → ${searchData?.Routs?.[0]?.Destination || "BOM"}`],
            ["📅 Departure", searchData?.Routs?.[0]?.TravelDate || ""],
            isRoundTripSearch ? ["📅 Return", searchData?.Routs?.[1]?.TravelDate || ""] : null,
            ["Traveller", `Adult: ${searchData?.AdultCount || 1}, Child: ${searchData?.ChildCount || 0}, Infant: ${searchData?.InfantCount || 0}`],
            ["Class", "Economy"],
          ].filter(Boolean).map(([lbl, val]) => (
            <div key={lbl} style={S.metaItem}>
              <span style={S.metaLabel}>{lbl}</span>
              <span style={S.metaVal}>{val}</span>
            </div>
          ))}
        </div>
        <button style={S.modifyBtn} onClick={() => setShowModify((v) => !v)}>
          Modify {showModify ? "▲" : "▼"}
        </button>
      </div>

      {showModify && (
        <div style={{ maxHeight: 500 }}>
          <ModifyPanel tripType={tripType} setTripType={setTripType} navigate={navigate} />
        </div>
      )}

      <div style={S.mainArea}>
        <FilterPanel filters={filters} setFilters={setFilters} />
        <div style={S.resultsArea}>
          <div style={S.sortTabs}>
            {["Best", "Cheapest", "Fastest"].map((tab, i) => (
              <div key={tab} onClick={() => setSortTab(tab)} style={{ ...S.sortTab, background: sortTab === tab ? "#F0F4FF" : "#fff", borderRight: i < 2 ? "1px solid #E8EAF0" : "none" }}>
                <div style={{ fontWeight: 600, fontSize: 12, color: sortTab === tab ? "#1a73e8" : "#1a1a2e" }}>{tab}</div>
                <div style={{ fontSize: 11, color: "#9295A4" }}>
                  {typeof tabMeta[tab].price === "number" ? `₹${tabMeta[tab].price.toLocaleString("en-IN")}` : tabMeta[tab].price}
                  {" · "}{tabMeta[tab].dur}
                </div>
              </div>
            ))}
          </div>  

<div style={S.navBtns}>
  <button
    style={{ ...S.navBtn, opacity: visibleCount <= ITEMS_PER_PAGE ? 0.5 : 1 }}
    disabled={visibleCount <= ITEMS_PER_PAGE}
    onClick={() => setVisibleCount((v) => Math.max(ITEMS_PER_PAGE, v - ITEMS_PER_PAGE))}
  >
    ◀ Prev 10
  </button>

  <span style={{ padding: "6px 14px", fontSize: 12, color: "#6B6F80" }}>
    {filteredFlights.length} flights · Showing {Math.min(visibleCount, filteredFlights.length)} · Page {currentPageDisplay} / {totalPages}
  </span>

  <button
    style={{ ...S.navBtn, opacity: !hasMore ? 0.5 : 1 }}
    disabled={!hasMore}
    onClick={() => setVisibleCount((v) => v + ITEMS_PER_PAGE)}
  >
    Next 10 ▶
  </button>
</div>

          <div style={S.colHead}>
            <span>Airline</span>
            <span style={{ textAlign: "center" }}>Departure</span>
            <span style={{ textAlign: "center" }}>Duration</span>
            <span style={{ textAlign: "center" }}>Arrival</span>
            <span style={{ textAlign: "right" }}>Fare</span>
          </div>

          {paginatedFlights.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 0", color: "#9295A4", fontSize: 14 }}>
              No flights match your filters.
            </div>
          ) : (
            <>
              {paginatedFlights.map((f, i) => (
                <FlightCard
                  key={i}
                  flight={f}
                  index={i}
                  sessionData={sessionData}
                  isDomestic={isDomestic}
                  searchData={searchData}
                />
              ))}
              {hasMore && (
                <div style={S.loadingMore}>Neeche scroll karo aur flights load hongi…</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );  
}
